import React, { Component } from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { HashLink as Link } from 'react-router-hash-link';
import { Spring } from 'react-spring';
import { ToastContainer, toast, cssTransition } from 'react-toastify';
import SweetAlert from 'sweetalert-react';

import {
  APIHandler,
  BackVideo,
  DataHandler,
  LanguageSelect,
  StorageHandler,
  StoreButtons,
} from 'C4';
import { bgVideo, storageKeys } from 'settings';

import 'react-toastify/dist/ReactToastify.css';
import Logo from 'assets/images/logo/logo3.png';

const Zoom = cssTransition({
  enter: 'zoomIn',
  exit: 'zoomOut',
  duration: [500, 800],
});

export default class HomeView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      query: '',
      unreadMessageCount: 0,
      lastCheckedMessages: '1993-01-10',
      appId: -1,
      userStatus: 'startTraining',
      noAgent: false,
    };
  }

  componentWillMount() {
    document.body.classList.add('no-scroll');
    StorageHandler.load(storageKeys.lastCheckedMessage).then((res) => {
      if (res) {
        this.setState({ lastCheckedMessages: res });
      }
      this.checkForUnreadMessages();
    });

    StorageHandler.load(storageKeys.user).then((res) => {
      if (res.training_graduated) {
        return this.setState({ userStatus: 'graduated' });
      }
      if (res.training_started) {
        return this.setState({ userStatus: 'continueTraining' });
      }
      return this.setState({ userStatus: 'startTraining' });
    });
  }

  componentDidMount() {
    const d = new Date(Date.now());
    const leading = val => `0${val}`.slice(-2);

    this.addEvent();
    StorageHandler.load(storageKeys.user).then((user) => {
      if (user && user.sales_companion_registered === null) {
        const obj = user;
        const date = `${d.getFullYear()}-${leading(d.getMonth() + 1)}-${leading(d.getDate())}`;
        DataHandler.matchAppId().then((appId) => {
          APIHandler.updateUser(appId, obj.email, [
            { param: 'sales_companion_registered', val: date },
          ]).then((res) => {
            if (res) {
              obj.sales_companion_registered = date;
              StorageHandler.save(storageKeys.user, obj);
            }
          });
        });
      }
    });
    DataHandler.matchAppId().then((appId) => {
      this.setState({ appId });
      StorageHandler.exists(storageKeys.announcement).then((announcementShownBefore) => {
        if (!announcementShownBefore) {
          APIHandler.getAnnouncement(appId).then((res) => {
            console.log(res);
            const TaostContent = () => (
              <div>
                <p>
                  <a
                    href={res[0].weblink}
                    key="toast"
                    target="_blank"
                  >
                    <img src={res[0].img} />
                    <span dangerouslySetInnerHTML={{__html: res[0].message}} />
                  </a>
                </p>
              </div>
            );

            if (res.length !== 0) {
              toast.info(TaostContent, {
                position: 'top-center',
                autoClose: false,
                closeOnClick: false,
                transition: Zoom,
                hideProgressBar: true,
                pauseOnHover: true,
                draggable: true,
                toastId: 'announcement',
                onClose: () =>
                  StorageHandler.save(
                    storageKeys.announcement,
                    res.copy,
                    604800,
                  ), // expires in a week
              });
            }
            return null;
          });
        }
      });
    });
  }

  componentWillUnmount() {
    document.body.classList.remove('no-scroll');
  }

  setQuery() {
    const { query } = this.state;
    if (query.length > 0) {
      StorageHandler.save(storageKeys.lastSearchQuery, query);
    }
  }

  addEvent() {
     // Event snippet for 2022 - US - Campaign Specialist Program - Main Pageview on https://www.canadaspecialistprogram.com/main: Please do not remove.
     if (window.location.hostname === 'canadaspecialistprogram.us' || window.location.hostname === 'www.canadaspecialistprogram.us'
     || window.location.hostname === 'canadaspecialist.us ' || window.location.hostname === 'www.canadaspecialist.us'
     || window.location.hostname === 'canadaspecialistprogram.com' || window.location.hostname === 'www.canadaspecialistprogram.com' 
     || window.location.hostname === 'canadaspecialist.com' || window.location.hostname === 'www.canadaspecialist.com' || window.location.hostname === 'localhost') { 
      window.gtag('event', 'conversion', {
        'allow_custom_scripts': true,
        'send_to': 'DC-6628166/csp/2022-00+standard',
        event_category: 'conversion',
        event_label: 'home_page_visit'
      });  
    }
  }
  checkForUnreadMessages() {
    DataHandler.requestWithId(
      APIHandler.getUnreadMessages,
      this.state.lastCheckedMessages,
    ).then((res) => {
      this.setState({ unreadMessageCount: res.missed_items[0].count });
    });
  }

  render() {
    const {
      unreadMessageCount, appId, userStatus, noAgent,
    } = this.state;


    const close = () => {
      this.setState({
        noAgent: false,
      });
    };

    return (
      <div className="homeContainer">
        {bgVideo && <BackVideo />}
        <div className="bgHome" />
        <div className="buttonWrapper">
          Download now:
          <StoreButtons />
        </div>
        <LanguageSelect />
        <Spring
          from={{ transform: 'translateY(30%)', opacity: 0 }}
          to={{ transform: 'translateY(0%)', opacity: 1 }}
        >
          {props => (
            <div className="homeView" style={props}>
              <div className="homeView__title">
                <img src={`/${Logo}`} className="homeLogo" alt="logo" />
                <h1>{i18n.translate('homeScreen.title')}</h1>
                <div className="homeView__title--action">
                  <form>
                    <Link
                      to="/main/search"
                      onClick={() => {
                        this.setQuery();
                      }}
                    >
                      <button type="submit" className="searchButton">
                        <FontAwesomeIcon icon={['fas', 'search']} />
                      </button>
                    </Link>
                    <input
                      type="text"
                      placeholder={i18n.translate('general.search')}
                      onChange={(e) => {
                        const { value } = e.target;
                        this.setState({ query: value });
                      }}
                    />
                    <Link
                      to="/main/search"
                      onClick={() => {
                        this.setQuery();
                      }}
                    >
                      <button type="submit" className="searchButton">
                        <FontAwesomeIcon icon={['fas', 'search']} />
                      </button>
                    </Link>
                  </form>
                  <div className="homepage__buttons">
                    <Link to="/main/messages" className="startTrain">
                      {unreadMessageCount === 0 && 
                        <p>
                          {i18n.translate('nav.messages')}
                        </p>
                      }
                      {unreadMessageCount > 0 && 
                        <p>
                          {i18n.translate(`${unreadMessageCount === 1 ? 'general.message' : 'general.messagePlural'}`, { count: unreadMessageCount })}
                        </p>
                      }
                      </Link>
                    {appId === 808 && 
                      <Link to="/main/sell/contact" className="startTrain">
                      <p>{i18n.translate('general.contact')}</p>
                    </Link>
                    }
                  </div>
                  {appId === 808 &&<style>{'\
                  .homepage__buttons { grid-template-columns: 1fr 1fr; grid-gap: 5rem; } .startTrain { width: 16rem; } '}
                  </style>}
                </div>
              </div>
            </div>
          )}
        </Spring>
        <div className="top-bar" />
        <div className="bottom-bar" />
        {/* <SweetAlert
          title="This feature is Coming Soon"
          show={noAgent}
          imageUrl={Logo2}
          imageWidth="50rem"
          imageHeight="50rem"
          html
          text=""
          customClass="noAgent"
          showConfirmButton={false}
          cancelButtonText={i18n.translate('general.close')}
          showCancelButton
          onConfirm={close}
          onCancel={close}
          onEscapeKey={close}
          onOutsideClick={close}
        /> */}
        <ToastContainer
          draggablePercent={60}
          autoClose={false}
          newestOnTop
          rtl={false}
          pauseOnVisibilityChange
          draggable
        />
      </div>
    );
  }
}
